import { atom } from "jotai";

export const playerElementAtom = atom(null);
export const isPlayerOpenAtom = atom(false);
export const audioAtom = atom(null);
export const isPlayingAtom = atom(false);
export const audioObjectAtom = atom(null);
export const isAudioLoadingAtom = atom(false);
export const progressTimeAtom = atom(0);
